import { isHeic, convertHeicToJpeg } from '../../../lib/image_compressor';

// 画像の EXIF orientation を canvas で正規化しつつ、
// 上限サイズまで縮小して JPEG 再エンコードした File を返す。
// AWS Rekognition は EXIF 回転に依存して顔を検出するわけではないため、
// 画素そのものを正立させた状態でアップロードする必要がある。
const MAX_DIMENSION = 2000;
const JPEG_QUALITY = 0.92;

const createOrientedBitmap = async (file) => {
  // imageOrientation: 'from-image' で EXIF に従って自動回転
  // Safari/Chrome/Firefox の現行版は対応済み
  try {
    return await createImageBitmap(file, { imageOrientation: 'from-image' });
  } catch (_) {
    // フォールバック: orientation 未対応ブラウザでは無回転
    return await createImageBitmap(file);
  }
};

const normalizeImage = async (file, fileName = 'photo.jpg') => {
  if (!file) {
    return null;
  }

  // Chrome/Firefox は HEIC をネイティブにデコードできず createImageBitmap が失敗するため、
  // 先に heic2any(libheif WASM) で JPEG へ変換してから canvas で正規化する。
  let source = file;
  if (isHeic(file)) {
    source = await convertHeicToJpeg(file);
  }

  const bitmap = await createOrientedBitmap(source);

  const scale = Math.min(1, MAX_DIMENSION / Math.max(bitmap.width, bitmap.height));
  const targetWidth = Math.round(bitmap.width * scale);
  const targetHeight = Math.round(bitmap.height * scale);

  const canvas = document.createElement('canvas');
  canvas.width = targetWidth;
  canvas.height = targetHeight;
  const ctx = canvas.getContext('2d');
  ctx.drawImage(bitmap, 0, 0, targetWidth, targetHeight);

  if (typeof bitmap.close === 'function') {
    bitmap.close();
  }

  const blob = await new Promise((resolve) => {
    canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY);
  });

  if (!blob) {
    throw new Error('画像の変換に失敗しました');
  }

  return new File([blob], fileName, { type: 'image/jpeg' });
};

export default normalizeImage;
